module.exports = __webpack_public_path__ + "img/home-icon.57908025.svg";